import { render } from "./GlobalModal.vue?vue&type=template&id=25e2fd8a&scoped=true"
import script from "./GlobalModal.vue?vue&type=script&lang=js"
export * from "./GlobalModal.vue?vue&type=script&lang=js"

import "./GlobalModal.vue?vue&type=style&index=0&id=25e2fd8a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25e2fd8a"]])

export default __exports__